/** @format */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';

import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Heading/CardHeaderExt';

import adescomStyle from 'assets/jss/adescom/adescomStyle';
import Storage from '@material-ui/icons/Storage';
import { provActions, provisionigConstants } from '../../../modules/provisioning/action';
import ViewPlkGetList from './ViewPlkGetList';
import { store } from '../../../core/store';
import { provisioningReducers } from '../../../modules/provisioning/reducers';

class ViewPlkList extends PureComponent {
    constructor(props) {
        super(props);

        store.injectReducer('provisioningReducers', provisioningReducers);
        this.state = {
            requestId: '/' + this.props.match.params.id,
            viewItem: null,
        };
    }

    componentDidMount() {
        this.initial();
    }

    initial = () => {
        const { dispatch } = this.props;
        dispatch(provActions.get(FormGeneralHelper.getByUri(this.state.requestId), provisionigConstants.PLK_LIST_VIEW_ITEM));
    };

    static getDerivedStateFromProps(props, state) {
        if (props.viewItem && props.viewItem !== state.viewItem) {
            state.viewItem = props.viewItem;
        }
        return state;
    }

    render() {
        const { viewItem } = this.state;

        if (viewItem) {
            return (
                <GridContainer>
                    <GridItem xs={12} md={12} lg={12}>
                        <Card>
                            {!viewItem && <CardHeader icon={<Storage />} trans="prov:h.plk_request_operation_response_detail" />}

                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12}>
                                        {viewItem && viewItem.table === 'GET' && <ViewPlkGetList viewItem={viewItem} />}
                                        {viewItem && viewItem.table === 'SET' && <div />}
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            );
        }
        return null;
    }
}

ViewPlkList.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    const { provisioningReducers } = state;
    if (provisioningReducers && provisioningReducers.viewItem) {
        return {
            type: provisioningReducers.type,
            viewItem: provisioningReducers.viewItem,
        };
    }
    return {};
};
const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));
const Enhance = enhance(ViewPlkList);
export default Enhance;
